import React from 'react';
import styled from '@emotion/styled';
import { Box, Badge as RooBadge } from '@qga/roo-ui/components';

import getProcuredOfferSash from '@/utils/getProcuredOfferSash';
import {
  HeroDuration,
  HeroSash,
} from '@/v2/services/sanity/types/api/response/homepageHero';

const Wrapper = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
`;

interface BadgeProps {
  sash?: HeroSash;
  duration?: Pick<HeroDuration, 'end'>;
}

const Badge = ({ sash, duration }: BadgeProps) => {
  if (!sash) return null;

  const { label, variation, extended } = sash;

  // A lot of data for this badge isn't required in Sanity.
  // Safely return nothing if fields that are required to render the specific badge don't exist.
  if (variation === 'none') return null;
  if (variation == 'customText' && !label) return null;
  if (variation === 'dateDays' && !duration?.end) return null;

  const badgeProps =
    variation === 'dateDays'
      ? getProcuredOfferSash({
          saleDateRange: {
            end: duration?.end,
          },
          extended,
        })
      : {
          icon: undefined,
          type: undefined,
          text: label,
        };

  const { icon, type, text } = badgeProps;

  if (!text) return null;

  return (
    <Wrapper color="greys.charcoal" data-testid="hero-badge">
      <RooBadge
        iconName={icon}
        type={type}
        text={text}
        fontWeight={600}
        // NOTE: 9px is a hack - setting 10px will have some background artifact visible
        borderRadius={['0 0 10px 0', '0 0 10px 0', '9px 0 10px 0']}
      />
    </Wrapper>
  );
};

export default Badge;
